import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "profileSettingsPage",
  class: "container mb-3"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-8 col col-sm-12 profile-page" }
const _hoisted_4 = { class: "profile-settings__main-wrapper" }
const _hoisted_5 = { class: "profile-settings__header-wrapper" }
const _hoisted_6 = { class: "profile-settings__header" }
const _hoisted_7 = { class: "profile-settings__setting" }
const _hoisted_8 = { class: "profile-settings__setting-wrapper" }
const _hoisted_9 = ["for"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "customer-loader"
}
const _hoisted_12 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_13 = { class: "font-small error-color" }
const _hoisted_14 = {
  key: 0,
  class: "font-small success-color"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomerProfileNavComponent = _resolveComponent("CustomerProfileNavComponent")!
  const _component_CheckBoxComponent = _resolveComponent("CheckBoxComponent")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CustomerProfileNavComponent, {
        id: "sideNav",
        class: "col-lg-4 col-sm-12 side-nav"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('settings')), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.settings, (setting) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "profile-settings__setting" }, null, -1)),
                _createVNode(_component_CheckBoxComponent, {
                  onClick: ($event: any) => (setting.value = !setting.value),
                  state: setting.value
                }, {
                  "checkbox-text": _withCtx(() => [
                    _createElementVNode("label", {
                      for: setting.key
                    }, _toDisplayString(_ctx.$t(setting.key)), 9, _hoisted_9)
                  ]),
                  _: 2
                }, 1032, ["onClick", "state"])
              ])
            ]))
          }), 256)),
          _createElementVNode("button", {
            class: _normalizeClass(["profile-settings__save-button", {'less-padding-06': _ctx.loading}]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.save())),
            disabled: _ctx.loading
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('save')) + " ", 1),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11))
              : _createCommentVNode("", true)
          ], 10, _hoisted_10),
          (_ctx.errors.length || _ctx.success)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t(error)), 1))
                }), 256)),
                (_ctx.success)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('saved')), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}